import { useProfile } from "../context/ProfileContext";

export default function Vitals() {
  const PROFILE = useProfile();
  return (
    <section id="vitals" className="relative bg-[#0A0A0A] py-24 sm:py-32" data-testid="vitals-section">
      <div className="max-w-screen-2xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12">
          <div>
            <div className="text-[10px] tracking-[0.3em] uppercase text-[#E60000] font-bold mb-4">
              01 — Measurables
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl uppercase font-bold tracking-tight text-white leading-none">
              The Tape <span className="text-[#8A8A8A]">Doesn't Lie</span>
            </h2>
          </div>
          <p className="max-w-md text-[#8A8A8A] text-base leading-relaxed">
            Verified measurables captured in-season at A5 Volleyball Club. Faith plays bigger than her listed
            height — long arms, fast tempo at the net.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 border-t border-l border-white/10" data-testid="vitals-grid">
          {PROFILE.measurables.map((m, i) => (
            <div
              key={m.label}
              className="border-r border-b border-white/10 p-8 lg:p-10 flex flex-col gap-4 hover:bg-[#111111] transition-colors group"
              data-testid={m.testid}
            >
              <div className="flex items-center justify-between">
                <span className="text-[10px] tracking-[0.3em] uppercase text-[#E60000] font-bold">
                  0{i + 1}
                </span>
                <span className="text-[10px] tracking-[0.2em] uppercase text-[#8A8A8A]">
                  {m.label}
                </span>
              </div>
              <div className="font-display text-5xl lg:text-7xl uppercase font-black tracking-tighter text-white group-hover:text-[#E60000] transition-colors leading-none">
                {m.value}
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 border-l border-white/10 mt-px">
          <div className="border-r border-b border-white/10 p-8 flex items-center gap-6">
            <div className="font-display text-5xl text-white">{PROFILE.height}</div>
            <div>
              <div className="text-[10px] tracking-[0.25em] uppercase text-[#E60000] font-bold">Listed Height</div>
              <div className="text-sm text-[#8A8A8A] mt-1">Verified by Westminster Athletics</div>
            </div>
          </div>
          <div className="border-r border-b border-white/10 p-8 flex items-center gap-6">
            <div className="font-display text-5xl text-white">MB</div>
            <div>
              <div className="text-[10px] tracking-[0.25em] uppercase text-[#E60000] font-bold">Primary Position</div>
              <div className="text-sm text-[#8A8A8A] mt-1">Middle Blocker · Fast Tempo</div>
            </div>
          </div>
          <div className="border-r border-b border-white/10 p-8 flex items-center gap-6">
            <div className="font-display text-5xl text-white">27</div>
            <div>
              <div className="text-[10px] tracking-[0.25em] uppercase text-[#E60000] font-bold">Graduation</div>
              <div className="text-sm text-[#8A8A8A] mt-1">Class of 2027</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
